(function(){
  function money(p){return '\u00a3'+(p/100).toFixed(2)}
  function init(){
    var box=document.querySelector('[data-cl-ship]'); if(!box) return;
    var th=parseInt(box.getAttribute('data-threshold'),10)||4900, price=parseInt(box.getAttribute('data-price'),10)||0, cartTotal=0;
    var qty=document.querySelector('.cl-pdp__buy input[name="quantity"]');
    var msg=box.querySelector('p'), bar=box.querySelector('.cl-ship__bar span');
    function render(){
      var q=qty?Math.max(1,parseInt(qty.value,10)||1):1, tot=cartTotal+price*q, left=th-tot;
      if(left<=0){box.classList.add('is-free');msg.innerHTML='This order qualifies for <b>free UK delivery</b>.';bar.style.width='100%'}
      else{box.classList.remove('is-free');msg.innerHTML='Add <b>'+money(left)+'</b> more for <b>free UK delivery</b> (orders over '+money(th).replace('.00','')+').';bar.style.width=Math.min(100,Math.round(tot/th*100))+'%'}
    }
    if(qty){['input','change'].forEach(function(e){qty.addEventListener(e,render)});document.querySelectorAll('[data-cl-qty] button').forEach(function(b){b.addEventListener('click',function(){setTimeout(render,0)})})}
    render();
    if(window.fetch){fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null}).then(function(c){if(c&&typeof c.total_price==='number'){cartTotal=c.total_price;render()}}).catch(function(){})}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
